// extracted by mini-css-extract-plugin
export default {"pageContainer":"Page_pageContainer__Kb1LH","pageContent":"Page_pageContent__4mhYh"};